import { initializeApp } from 'firebase/app';
import { getAuth, initializeAuth, indexedDBLocalPersistence, browserLocalPersistence } from 'firebase/auth';
import { getFirestore, initializeFirestore, persistentLocalCache, persistentMultipleTabManager } from 'firebase/firestore';
import { getFunctions, connectFunctionsEmulator } from 'firebase/functions';
import { getStorage } from "firebase/storage";
import { initializeAppCheck, ReCaptchaEnterpriseProvider } from 'firebase/app-check';





const firebaseConfig = {
  apiKey: "AIzaSyBbY0zTftR_brnnVD97IsIwDhFdHZMfD8k",
  authDomain: "flexitimebooking-app.firebaseapp.com",
  projectId: "flexitimebooking-app",
  storageBucket: "flexitimebooking-app.firebasestorage.app",
  messagingSenderId: "1080418878557",
  appId: "1:1080418878557:web:96335a7583c781b135b9b4"
};

const app = initializeApp(firebaseConfig);

// App Check (reCAPTCHA Enterprise / "Fraud Defense"): bewijst bij calls naar de
// beschermde Cloud Functions dat ze uit de echte app komen en niet uit een los
// script dat enkel de (publieke) firebaseConfig kent. De sitesleutel is publiek.
//
// BEWUST UITGESTELD gestart (startAppCheck hieronder) en niet meteen bij het laden:
// zodra App Check actief is wacht elke Firestore-/Functions-call eerst op een token,
// en een nieuwe bezoeker moet daarvoor eerst reCAPTCHA downloaden (1 tot 2,5 seconden
// extra, op elke eerste paginalading van het uur). De eerste, leesgerichte calls (de
// publieke boekingspagina, het dashboard) lopen daarom zonder token (die functies
// staan niet op enforceAppCheck, zie CLAUDE.md); schrijvende en account-calls hebben
// het token intussen binnen. Firestore en Storage dwingen App Check NIET af (de
// regels beschermen die al); zet dat niet aan zonder deze volgorde aan te passen.
// Lokaal (npm start) logt de SDK een debug-token dat in de Console geregistreerd
// moet worden.
const APP_CHECK_SITE_KEY = '6LcrptwtAAAAABsdMcY4fQot_oSBTNwVt8jmFk_J';
let appCheckStarted = false;
export function startAppCheck() {
  if (appCheckStarted) return;
  appCheckStarted = true;
  if (process.env.NODE_ENV !== 'production') {
    // eslint-disable-next-line no-restricted-globals
    self.FIREBASE_APPCHECK_DEBUG_TOKEN = true;
  }
  try {
    initializeAppCheck(app, {
      provider: new ReCaptchaEnterpriseProvider(APP_CHECK_SITE_KEY),
      isTokenAutoRefreshEnabled: true
    });
  } catch (error) {
    console.error('App Check kon niet starten:', error);
  }
}
const scheduleAppCheck = () => setTimeout(startAppCheck, 1500);
if (document.readyState === 'complete') {
  scheduleAppCheck();
} else {
  window.addEventListener('load', scheduleAppCheck, { once: true });
}

const functions = getFunctions(app, 'us-central1');
// De functies waar klanten (anoniem) op wachten staan in europe-west1, naast de Firestore-
// database (eur3) en de klanten, i.p.v. aan de overkant van de oceaan. Zie
// functions/src/lib/runtime.js. De overige functies (dashboard, betalingen, webhooks)
// blijven in us-central1.
const functionsEu = getFunctions(app, 'europe-west1');
// Auth enkel voor e-mail/wachtwoord (geen popup- of redirect-aanmelding in de app):
// initializeAuth zonder popupRedirectResolver laat die code uit de bundel. De bewaarde
// sessie staat in dezelfde opslag als bij getAuth, bestaande aanmeldingen blijven dus
// geldig. De terugval op getAuth (Auth bestond al door HMR) staat bewust enkel in dev:
// een getAuth-verwijzing in de productiebundel haalt de popupcode er weer in.
function maakAuth() {
  const opties = { persistence: [indexedDBLocalPersistence, browserLocalPersistence] };
  // Bewust if/else: webpack haalt bij een constante voorwaarde enkel de dode TAK weg,
  // niet de code die na een return volgt.
  if (process.env.NODE_ENV === 'production') {
    return initializeAuth(app, opties);
  } else {
    try {
      return initializeAuth(app, opties);
    } catch {
      return getAuth(app);
    }
  }
}

// Permanente Firestore-cache (IndexedDB, ook over meerdere tabbladen): na de
// Auth-wachtronde komen gegevens meteen van het toestel i.p.v. opnieuw van het
// netwerk. Bewuste afweging: deze cache wordt bij uitloggen NIET gewist (alleen de
// eigen startcache in utils/startCache.js); de beveiligingsregels blijven gelden.
// Terugval op de gewone cache als IndexedDB ontbreekt of Firestore al bestond (HMR).
// Niet op de pagina's voor klanten (boeken, boeking beheren): die bezoekers loggen nooit in en
// hebben geen gegevens om lokaal te bewaren, dus dat is enkel extra werk (IndexedDB openen,
// meerdere-tabbladen-bewaking) vóór de pagina iets toont.
function maakFirestore() {
  const klantenpagina = /^\/(book|manage-booking)\//.test(window.location.pathname);
  if (klantenpagina) {
    return getFirestore(app);
  }
  try {
    return initializeFirestore(app, {
      localCache: persistentLocalCache({ tabManager: persistentMultipleTabManager() })
    });
  } catch {
    return getFirestore(app);
  }
}

const auth = maakAuth();
const db = maakFirestore();
const storage = getStorage(app);

export const stripePublishableKey = 'pk_live_51PqvLuRt1ifBDSMDk4sIl1fnosw0peOlcE4lgD1alO8EEQMuqfxhuhWf6Fy1g40C0Mf4oV1h8L8vKX9ZoNdAcOxb00MaLlx7Mk';

// VAPID-publieke sleutel voor Web Push (pushmeldingen, Instellingen > Meldingen).
// TODO Marc: genereren via Firebase Console > Projectinstellingen > Cloud Messaging
// > "Web Push-certificaten" > sleutelpaar genereren, en hier de publieke sleutel
// plakken. Dit is een publieke sleutel (net als firebaseConfig hierboven), geen
// geheim. Zolang dit de placeholder blijft, faalt enablePushNotifications() met
// een duidelijke console-foutmelding i.p.v. iets stil kapot te laten gaan.
export const vapidKey = 'BMbAu45YrwjFDeBFolc5ez1mKcSEyjgHFEVoPo-wXHDYbJiBWUw6fUwYL3koPiUvnxgq4Hd-rRTmw5sKfhkD564';

export { app, auth, db, storage, functions, functionsEu };